
import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Swal from 'sweetalert2';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import DashboardLayout from '../layouts/DashboardLayout';
import Tabular from '../components/Tabular';
// modales dinamicos
import ItemAddModal from '../components/itemAddModal';
import ItemUpdateModal from '../components/itemUpdateModal';
import {
  getAllitem,
  deleteitem,
} from '../api/item.api';

const ItemPage = ({ history, token, }) => {
  const [openAddModal, setOpenAddModal] = useState(false);
  const [openUpdateModal, setOpenUpdateModal] = useState(false);
  const [doc, setDoc] = useState(undefined);
  const [data, setData] = useState([]);
  useEffect(() => {
    getAllitem({ token }).then((res) => {
      setData(res.data);
    }).catch((error) => {
      console.log(error);
    });
  }, []);
  const handleSuccess = () => {
    getAllitem({ token }).then((res) => {
      setData(res.data);
    }).catch((error) => {
      console.log(error);
    });
  }
  return (
    <DashboardLayout history={history}>
      {/* Modal para agregar item */}
      <ItemAddModal
        handleClose={() => setOpenAddModal(!openAddModal)}
        open={openAddModal}
        successAction={handleSuccess}
      />
      {/* Moal para actualizar un item */}
      <ItemUpdateModal
        handleClose={() => setOpenUpdateModal(!openUpdateModal)}
        doc={doc}
        open={openUpdateModal}
        successAction={handleSuccess}
      />
      <h2 className="text-center mb-4">
        item
      </h2>
      <div className="text-right mb-2">
        <Button onClick={() => setOpenAddModal(true)} variant="outlined" color="primary">
          Agregar
        </Button>
      </div>
      <div>
        <Tabular
          title="Item"
          columns={[
            {
							title: 'Descripcion',
							field: 'description'
						},
						{
							title: 'Tipo',
							field: 'type'
						},
						{
							title: 'Transmision',
							field: 'idTransmision'
						},
						{
							title: 'Pais',
							field: 'idCountry'
						},
						{
							title: 'Ciudad',
							field: 'city'
						},
						{
							title: 'Usuario',
							field: 'idUser'
						},
						{
							title: 'Genero',
							field: 'gender'
						},
						{
							title: 'Perdido',
							field: 'lost'
						},
						{
							title: 'Color',
							field: 'color'
						},
						{
							title: 'Numero de microship',
							field: 'numberMicroship'
						},
						{
							title: 'Raza',
							field: 'colorcast'
						},
						{
							title: 'Especie',
							field: 'species'
						},
						{
							title: 'Veterinaria',
							field: 'idVeterinaryClinic'
						},
						{
							title: 'Información extra',
							field: 'extraInformation'
						},
						{
							title: 'Medicamentos',
							field: 'medicines'
						},
						{
							title: 'Alergias',
							field: 'allergies'
						},
						{
							title: 'Telefono1',
							field: 'phone1'
						},
						{
							title: 'Telefono 2',
							field: 'phone2'
						},
						{
							title: 'Estado / Departamento',
							field: 'idState'
						},
						{
							title: 'Vacunas',
							field: 'vaccines'
						},
						{
							title: 'Cirugías',
							field: 'surgeries'
						},
						{
							title: 'Número de partos',
							field: 'childbirth'
						},
						{
							title: 'Pedigree',
							field: 'pedigree'
						},
						{
							title: 'Desparasitantes',
							field: 'dewormers'
						},
						{
							title: 'Fracturas',
							field: 'fractures'
						},
						{
							title: 'Cicatrices',
							field: 'scars'
						},
						{
							title: 'Recompensa',
							field: 'reward'
						},
						{
							title: 'Marca',
							field: 'brand'
						},
						{
							title: 'IMEI #',
							field: 'imei'
						},
						{
							title: 'Fecha de nacimiento',
							field: 'age'
						},
						{
							title: 'Valido',
							field: 'validItem'
						},
						{
							title: 'Numero de Placa',
							field: 'numberPlate'
						},
						{
							title: 'Posee Recompensa',
							field: 'haveReward'
						},
						{
							title: 'Modelo',
							field: 'textModel'
						},
						{
							title: 'Archivo PDF',
							field: 'idPdf'
						},

            {
              title: 'Acciones',
              field: '_id',
              render: (rowData) => {
                const {_id} = rowData;
                return (
                  <div>
                    <IconButton onClick={() => history.push('/item/item/one/' + _id)}>
                      <VisibilityIcon/>
                    </IconButton>
                    <IconButton
                      onClick={() => {
                        setOpenUpdateModal(true);
                        setDoc(rowData);
                      }}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      onClick={async () => {
                        try {
                          const resSwal = await Swal.fire({
                            icon: 'info',
                            title: 'Deseas eliminar este registro',
                            confirmButtonText: 'Si',
                            showCancelButton: true
                          });
                          if (resSwal.isConfirmed) {
                            await deleteitem({ token, _id });
                            alert('Se elimino el dato.');
                            handleSuccess();
                          }
                        } catch (error) {
                          if (error.info) {
                            Swal.fire({
                              position: 'top-end',
                              icon: 'error',
                              title: error.info,
                              showConfirmButton: false,
                              timer: 1500,
                            });
                          } else {
                            Swal.fire({
                              position: 'top-end',
                              icon: 'error',
                              title: 'Error no se pudo eliminar',
                              showConfirmButton: false,
                              timer: 1500,
                            });
                          }
                        }
                      }}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </div>
                );
              },
            }
          ]}
          data={data}
        />
      </div>
    </DashboardLayout>
  );
}

const mapStateToProps = state => state.auth;

export default connect(mapStateToProps)(ItemPage);

